import { render, staticRenderFns } from "./dispensation5.vue?vue&type=template&id=e0d181a0&scoped=true"
import script from "./dispensation5.vue?vue&type=script&lang=js"
export * from "./dispensation5.vue?vue&type=script&lang=js"
import style0 from "./dispensation5.vue?vue&type=style&index=0&id=e0d181a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d181a0",
  null
  
)

export default component.exports